import(/* webpackMode: "eager" */ "/home/runner/work/care_link_worker/care_link_worker/src/app/error.tsx");
